import { useNavigate } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import { useTelegram } from '../context/TelegramContext'
import Header from '../components/Header'
import './Cart.css'

const Cart = () => {
  const navigate = useNavigate()
  const { cart, removeFromCart, updateQuantity, getCartTotal, clearCart, hapticFeedback } = useCart()
  const { showConfirm } = useTelegram()

  const handleRemove = async (item) => {
    const confirmed = await showConfirm('Удалить товар из корзины?')
    if (confirmed) {
      removeFromCart(item.product_id, item.size, item.color)
    }
  }

  const handleClearCart = async () => {
    const confirmed = await showConfirm('Очистить всю корзину?')
    if (confirmed) {
      clearCart()
    }
  }

  const handleCheckout = () => {
    hapticFeedback('medium')
    navigate('/checkout')
  }

  if (cart.length === 0) {
    return (
      <div className="cart">
        <Header title="Корзина" showBack={true} showCart={false} />
        <div className="cart-empty">
          <div className="empty-cart-icon">🛒</div>
          <h2>Корзина пуста</h2>
          <p>Добавьте товары из каталога</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            Перейти в каталог
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="cart">
      <Header title="Корзина" showBack={true} showCart={false} />
      
      {/* Header Actions */}
      <div className="cart-header">
        <h2>Товары ({cart.length})</h2>
        <button className="btn-clear" onClick={handleClearCart}>
          Очистить
        </button>
      </div>

      {/* Cart Items */}
      <div className="cart-items">
        {cart.map((item, index) => (
          <div key={`${item.product_id}-${item.size}-${item.color}-${index}`} className="cart-item fade-in">
            <div className="cart-item-image">
              {item.product.image_url || item.product.image_urls ? (
                <img 
                  src={(() => {
                    if (item.product.image_url) return item.product.image_url
                    try {
                      const urls = typeof item.product.image_urls === 'string' ? JSON.parse(item.product.image_urls) : item.product.image_urls
                      return urls && urls.length > 0 ? urls[0] : '/placeholder.jpg'
                    } catch (e) {
                      return '/placeholder.jpg'
                    }
                  })()}
                  alt={item.product.name}
                />
              ) : (
                <div className="cart-item-placeholder">📷</div>
              )}
            </div>

            <div className="cart-item-info">
              <h3 className="cart-item-name">{item.product.name}</h3>
              
              {(item.size || item.color) && (
                <div className="cart-item-options">
                  {item.size && <span className="option-badge">{item.size}</span>}
                  {item.color && <span className="option-badge">{item.color}</span>}
                </div>
              )}

              <div className="cart-item-footer">
                <div className="quantity-control">
                  <button
                    className="quantity-btn"
                    onClick={() => {
                      updateQuantity(item.product_id, item.size, item.color, item.quantity - 1)
                      hapticFeedback('light')
                    }}
                  >
                    −
                  </button>
                  <span className="quantity">{item.quantity}</span>
                  <button
                    className="quantity-btn"
                    onClick={() => {
                      updateQuantity(item.product_id, item.size, item.color, item.quantity + 1)
                      hapticFeedback('light')
                    }}
                  >
                    +
                  </button>
                </div>

                <div className="cart-item-price">
                  {item.product.price * item.quantity} ₽
                </div>
              </div>
            </div>

            <button
              className="btn-remove"
              onClick={() => handleRemove(item)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="cart-summary">
        <div className="summary-row">
          <span>Товары ({cart.length})</span>
          <span>{getCartTotal()} ₽</span>
        </div>
        <div className="summary-row total">
          <span>Итого</span>
          <span className="total-price">{getCartTotal()} ₽</span>
        </div>
      </div>

      {/* Checkout Button */}
      <div className="cart-actions">
        <button className="btn btn-primary btn-checkout" onClick={handleCheckout}>
          Оформить заказ • {getCartTotal()} ₽
        </button>
      </div>
    </div>
  )
}

export default Cart


